"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveSectionItemHandler = void 0;
var tslib_1 = require("tslib");
var general_1 = require("../../events/general");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var layoutValidation_1 = require("./validation/layoutValidation");
var layout_1 = require("../../store/layout");
var layout_2 = require("../../events/layout");
var arrayOps_1 = require("../../utils/arrayOps");
var redux_batched_actions_1 = require("redux-batched-actions");
function validateAndResolve(commandCtx) {
    var ctx = commandCtx.ctx, layout = commandCtx.layout, _a = commandCtx.cmd.payload, sectionIndex = _a.sectionIndex, toSectionIndex = _a.toSectionIndex, itemIndex = _a.itemIndex, toItemIndex = _a.toItemIndex, removeOriginalSectionIfEmpty = _a.removeOriginalSectionIfEmpty;
    if (!layoutValidation_1.validateSectionExists(layout, sectionIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to move item from non-existent section at " + sectionIndex + ". There are only " + layout.sections.length + " sections.");
    }
    var fromSection = layout.sections[sectionIndex];
    if (!layoutValidation_1.validateItemExists(fromSection, itemIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to move non-existent item from index " + itemIndex + ". There are only " + fromSection.items.length + " items.");
    }
    var itemToMove = fromSection.items[itemIndex];
    if (!layoutValidation_1.validateSectionPlacement(layout, toSectionIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to move item to a wrong section at index " + toSectionIndex + ". There are currently " + layout.sections.length + " sections.");
    }
    var targetSectionIndex = arrayOps_1.resolveRelativeIndex(layout.sections, toSectionIndex);
    var targetSection = layout.sections[targetSectionIndex];
    if (!layoutValidation_1.validateItemPlacement(targetSection, toItemIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to move item to a wrong location at index " + toItemIndex + ". Target section has " + targetSection.items.length + " items.");
    }
    var targetItemIndex = 0;
    if (sectionIndex === targetSectionIndex) {
        targetItemIndex = arrayOps_1.resolveRelativeIndex(targetSection.items, toItemIndex);
        if (itemIndex === targetItemIndex) {
            throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to move item to a same place where it already resides " + toItemIndex + ".");
        }
    }
    else {
        targetItemIndex = arrayOps_1.resolveIndexOfNewItem(targetSection.items, toItemIndex);
    }
    return {
        targetSectionIndex: targetSectionIndex,
        targetItemIndex: targetItemIndex,
        itemToMove: itemToMove,
        shouldRemoveSection: Boolean(removeOriginalSectionIfEmpty) && fromSection.items.length === 1,
    };
}
function moveSectionItemHandler(ctx, cmd) {
    var commandCtx, _a, _b, targetSectionIndex, targetItemIndex, itemToMove, shouldRemoveSection, _c, itemIndex, sectionIndex, targetSectionIndexUpdated;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = {
                    ctx: ctx,
                    cmd: cmd
                };
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectLayout)];
            case 1:
                commandCtx = (_a.layout = _d.sent(),
                    _a);
                _b = validateAndResolve(commandCtx), targetSectionIndex = _b.targetSectionIndex, targetItemIndex = _b.targetItemIndex, itemToMove = _b.itemToMove, shouldRemoveSection = _b.shouldRemoveSection;
                _c = cmd.payload, itemIndex = _c.itemIndex, sectionIndex = _c.sectionIndex;
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions(tslib_1.__spread([
                        layout_1.layoutActions.moveSectionItem({
                            sectionIndex: sectionIndex,
                            itemIndex: itemIndex,
                            toSectionIndex: targetSectionIndex,
                            toItemIndex: targetItemIndex,
                            undo: {
                                cmd: cmd,
                            },
                        })
                    ], (shouldRemoveSection
                        ? [
                            layout_1.layoutActions.removeSection({
                                index: sectionIndex,
                                undo: {
                                    cmd: cmd,
                                },
                            }),
                        ]
                        : []))))];
            case 2:
                _d.sent();
                targetSectionIndexUpdated = shouldRemoveSection && sectionIndex < targetSectionIndex ? sectionIndex - 1 : targetSectionIndex;
                return [2 /*return*/, layout_2.layoutSectionItemMoved(ctx, itemToMove, sectionIndex, targetSectionIndexUpdated, itemIndex, targetItemIndex, shouldRemoveSection, cmd.correlationId)];
        }
    });
}
exports.moveSectionItemHandler = moveSectionItemHandler;
//# sourceMappingURL=moveSectionItemHandler.js.map